import { useQuery } from "@tanstack/react-query"
import {
  fetchAnlagen,
  fetchEreignisse,
  fetchKvpProjekte,
  fetchTickets,
  fetchZeitbuchungen,
} from "@/lib/api"

/**
 * Stub-Seite je Modul (AP-3.1-Basis): zeigt den Endpoint-Durchstich
 * (Anzahl Datensätze aus dem jeweiligen Kern-Endpoint). Die Fach-UIs
 * kommen in AP-3.3ff. / AP-4.x.
 */

const FETCHERS: Record<string, () => Promise<unknown[]>> = {
  maschinen: fetchAnlagen,
  timetab: fetchZeitbuchungen,
  tickets: fetchTickets,
  ereignis: fetchEreignisse,
  kvp: fetchKvpProjekte,
}

export function ModulStubPage({
  modul,
  titel,
  untertitel,
}: {
  modul: string
  titel: string
  untertitel: string
}) {
  const { data, isLoading, isError } = useQuery({
    queryKey: [modul, "stub-count"],
    queryFn: FETCHERS[modul],
  })

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">{titel}</h1>
      <p className="mt-1 text-sm text-slate-600">{untertitel}</p>
      <div className="mt-6 rounded-lg border border-slate-200 bg-white p-6">
        <p className="text-sm text-slate-700">
          Modul-Grundgerüst (AP-3.1). Backend-Durchstich:{" "}
          {isLoading && <span className="text-slate-400">lädt …</span>}
          {isError && <span className="text-red-600">API nicht erreichbar</span>}
          {data && (
            <span className="font-medium text-slate-900">
              {data.length} Datensätze im Kern-Endpoint
            </span>
          )}
        </p>
      </div>
    </div>
  )
}
